import { jsx as h } from "react/jsx-runtime";
import { SvgIcon as o } from "../SvgIcon.js";
const m = (v) => /* @__PURE__ */ h(o, { ...v, children: /* @__PURE__ */ h("path", { d: "M2.4958 2.49585v5.00276h1.66759V5.33406l2.65047 2.66151 1.18167-1.18166-2.66151-2.65047h2.16455V2.49585H2.4958Zm15.0083 0h-5.0028v1.66759h2.1646l-2.6615 2.65047 1.1816 1.18166 2.6505-2.66151v2.16455h1.6676V2.49585Zm0 10.00555h-1.6676v2.1645l-2.6505-2.6615-1.1816 1.1817 2.6615 2.6504h-2.1646v1.6676h5.0028v-5.0027ZM7.49857 17.5041v-1.6676H5.33402l2.66151-2.6504-1.18167-1.1817-2.65047 2.6615v-2.1645H2.4958v5.0027h5.00277Z" }) });
export {
  m as FilePreview
};
//# sourceMappingURL=FilePreview.js.map
